import type { State } from '@/reducers/types';
import { SignUpAllowed } from '@/types';
import { createSlice } from '@reduxjs/toolkit';
import { addSignUpAllowed, deleteSignUpAllowed, getSignUpAllowed } from './actions';
import { logout } from '@/features/auth';

export interface SignUpAllowedState {
  signUpAllowed: SignUpAllowed | null;
}

const initialState: SignUpAllowedState = {
  signUpAllowed: { domains: [], emails: [] },
};

export const { name, reducer } = createSlice({
  name: 'signUpAllowed',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSignUpAllowed.fulfilled, (state, action) => {
        state.signUpAllowed = action.payload;
      })
      .addCase(addSignUpAllowed.fulfilled, (state, action) => {
        state.signUpAllowed = action.payload;
      })
      .addCase(deleteSignUpAllowed.fulfilled, (state, action) => {
        state.signUpAllowed = action.payload;
      })
      .addCase(logout.fulfilled, () => initialState);
  },
});

export const selectSignUpAllowed = (state: State) => state[name].signUpAllowed;
